// extracted by mini-css-extract-plugin
export default {"linkButton":"linkButton___Xz3Hm","footerRow":"footerRow___l9uAP","footerLinksRow":"footerLinksRow___C2Qub","footerText":"footerText____mg9H"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"linkButton\":\"linkButton___Xz3Hm\",\"footerRow\":\"footerRow___l9uAP\",\"footerLinksRow\":\"footerLinksRow___C2Qub\",\"footerText\":\"footerText____mg9H\"}";
        // 1793029703078
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  